import { useEffect, useState } from "react";
import { Database } from "lucide-react";
import { api } from "@/lib/api";

const Stat = ({ label, value, testid }) => (
  <div>
    <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="font-mono text-lg font-semibold" data-testid={testid}>{value}</div>
  </div>
);

export function DataCheck() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/dashboard/data-check").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);
  if (!d) return null;
  const live = d.env === "live";
  return (
    <div className="border border-border bg-card rounded-sm px-6 py-4 flex flex-wrap items-center gap-x-10 gap-y-4" data-testid="data-check-card">
      <div className="flex items-center gap-3">
        <Database className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm font-semibold">Data Tersimpan</span>
        <span data-testid="data-check-env"
          className={`text-[11px] font-bold px-2 py-0.5 rounded-sm ${live ? "bg-emerald-600 text-white" : "bg-amber-400 text-amber-950"}`}>
          {live ? "LIVE" : "PREVIEW"}
        </span>
      </div>
      <Stat label="Penawaran bulan ini" value={d.quotes_month} testid="data-check-quotes-month" />
      <Stat label="Nomor terakhir" value={d.last_number || "-"} testid="data-check-last-number" />
      <Stat label="Nomor berikutnya" value={d.next_number} testid="data-check-next-number" />
      <Stat label="Tim internal aktif" value={d.internal_active} testid="data-check-internal" />
    </div>
  );
}
